import httpUtil from "@/utils/httpUtil";

export const selectMaterialTypeList = params => httpUtil.get("/storeMaterialType", params);


export const addMaterialType = params => httpUtil.post("/storeMaterialType", params);


export const selectAllMaterialType = params => httpUtil.get("/storeMaterialType/noPage", params);


export const delMaterialType = params => httpUtil.post("/storeMaterialType/delete", params);
